<!--  -->
<template>
  <div class="rules-container">
    <div class="rules-content">
      <div class="rules-type">
        <img :src="currtentType.img" class="type-img" />
        <div class="type-text">
          <span class="text1">关联活动类型:</span>
          <span class="text2">{{currtentType.title}}</span>
        </div>
      </div>
      <div class="rules-global">
        <a-card title="全局规则配置" :class="cardClass">
          <a-form :model="globalState" :rules="globalRules" ref="globalFormRef">
            <a-form-item label="时区" name="timezone">
              <a-select
                v-model:value="globalState.timezone"
                style="width: 100%"
                placeholder="请选择时区"
                @change="selectHandleChange"
              >
                <a-select-option
                  v-for="(d,index) in timeZoneOption"
                  :key="d.label"
                  :value="d.label"
                >{{ d.label }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="活动时间">
              <a-range-picker
                v-model:value="globalState.time"
                :show-time="{ format: 'HH:mm' }"
                format="YYYY-MM-DD HH:mm"
                style="width: 100%;"
                :placeholder="['Start Time', 'End Time']"
              />
            </a-form-item>
            <!--邀请好友-->
            <template v-if="currtentType.id == 4">
              <a-form-item label="邀请上限">
                <a-input
                  v-model:value="globalState.limit"
                  placeholder="请输入邀请上限"
                  style="width: 100%"
                />
              </a-form-item>
              <a-form-item label="邀请类型" name="type" class="inviteClass">
                <a-radio-group
                  name="radioGroup"
                  v-model:value="globalState.type"
                  @change="radioChangeInvite"
                  style="width: 100%;text-align:left"
                >
                  <a-radio value="1">积分邀请</a-radio>
                  <a-radio value="2">奖励邀请</a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item label="增加积分:" v-if="globalState.type === '1'">
                <a-input v-model:value="globalState.addtionPoints" placeholder="请输入增加积分" />
              </a-form-item>
            </template>
            <!--抽奖-->
            <template v-if="currtentType.id == 2">
              <a-form-item label="抽奖类型" name="type">
                <a-radio-group
                  name="radioGroup"
                  v-model:value="globalState.type"
                  @change="radioChange"
                  style="width: 100%;text-align:left"
                >
                  <a-radio value="1">单个奖品</a-radio>
                  <a-radio value="2">多个奖品</a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item label="消耗积分:" v-if="globalState.type == 2">
                <a-input v-model:value="globalState.depletePoints" placeholder="请输入消耗积分" />
              </a-form-item>
            </template>
          </a-form>
        </a-card>
      </div>
      <div class="rules-body">
        <div class="rules-tree">
          <a-tree :tree-data="treeData" @select="treeSelect" v-model:selectedKeys="selectedKeys">
            <template #title="{ key: treeKey, title }">
              <a-tooltip placement="leftTop">
                <template #title>{{ title }}</template>
                <span class="icon-title">{{ title }}</span>
              </a-tooltip>
            </template>
          </a-tree>
        </div>
        <div class="rules-empty" v-if="!currentForm || currentForm.length < 1">
          <a-empty />
        </div>
        <div class="rules-form" v-else>
          <a-form
            ref="generateForm"
            class="rulesForm"
            :model="model"
            :disabled="true"
            :layout="rules.layout"
            :labelAlign="rules.labelAlign"
            :labelCol="rules.labelCol"
            :hideRequiredMark="rules.hideRequiredMark"
          >
            <div v-for="(item,index) in currentForm" :key="index">
              <GenerateFormItem
                v-model:model="model"
                :key="item.key"
                :element="item"
                :config="rules"
                :disabled="true"
              />
            </div>
          </a-form>
        </div>
      </div>
      <div class="rules-btn">
        <a-button type="primary" class="btn" :loading="loading" @click="submitChange">确定</a-button>
        <a-button class="btn" @click="router.push('/event/list/listItem')">取消</a-button>
      </div>
    </div>
    <a-drawer
      title="字段属性"
      placement="right"
      :closable="true"
      :mask="false"
      :width="drawWidth"
      v-model:visible="visible"
      @close="closeVisibleChange"
    >
      <RulesConfig
        v-model:select="rulesConfig"
        @datepcikerEndChange="datepcikerEndChange"
        @datepcikerStartChange="datepcikerStartChange"
        @voteDateChange="voteDateChange"
      />
    </a-drawer>
  </div>
</template>

<script>
import {
  defineComponent,
  computed,
  onMounted,
  reactive,
  toRefs,
  watchEffect,
  watch,
  ref
} from "vue";
import { useRouter, useRoute } from "vue-router";
import {
  getTreeDataByKey,
  getTreeRules,
  getTreeRulesConfig,
  deepClone
} from "@/utils/index";
import moment from "moment";
import momentTimezone from "moment-timezone";
import {
  activeDetail,
  contentConfig,
  ruleConfig,
  region
} from "@/api/index.js";
import { rulesConfigInterface } from "@/config/antd";
import GenerateFormItem from "../../components/generateFormItem.vue";
import RulesConfig from "../../components/rulesConfig";
import Icon from "@/layout/icon";
import { message } from "ant-design-vue";
import _ from "lodash";

export default defineComponent({
  components: {
    GenerateFormItem,
    RulesConfig,
    Icon
  },
  setup(props, content) {
    const router = useRouter();
    const route = useRoute();
    const state = reactive({
      treeData: [],
      selectedKeys: [],
      currentForm: null,
      visible: false,
      model: {},
      rulesConfigList: JSON.parse(JSON.stringify(rulesConfigInterface)),
      rules: {
        size: "default",
        hideRequiredMark: false,
        layout: "horizontal",
        labelAlign: "right",
        readonly: false
      },
      timeZoneOption: [],
      jackPotOption: [
        {
          value: "1",
          label: "全部"
        },
        {
          value: "2",
          label: "未中奖"
        },
        {
          value: "3",
          label: "已中奖"
        }
      ],
      loading: false,
      currentSelectKey: null,
      currentSelectRules: null,
      rulesEqual: false
    });
    let globalState = ref({});
    const globalFormRef = ref(null);
    const rulesRef = ref(null);
    const globalRules = {
      timezone: [
        {
          required: true,
          message: "请选择时区",
          trigger: "change"
        }
      ],
      type: [
        {
          required: true,
          message: "请选择类型",
          trigger: "change"
        }
      ]
    };
    const selectRules = {
      description: [
        {
          required: true,
          message: "请输入描述",
          trigger: "blur",
          type: "number"
        }
      ]
    };
    const cardClass = computed(() => {
      const { query } = route;
      switch (query.type) {
        case "1":
        case "3":
          return "rules-card2";
        case "4":
          return "rules-card3";
        case "2":
          return "rules-card";
      }
    });
    const rulesConfig = computed(() => {
      const { query } = route;
      let rulesItem = state.rulesConfigList.find(
        item => item.type === query.type
      );
      console.log(rulesItem, "eeeeeeee");
      if (rulesItem.type == "2" && !query.isDetail) {
        rulesItem = Object.assign(rulesItem, {
          frequencyLimit: []
        });
      }
      if (rulesItem.type == "2" && query.isDetail) {
        rulesItem.lotteryType = Number(globalState.value.type);
      }
      if (route.query.type === "4") {
        rulesItem.inviteType = Number(globalState.value.type);
      }
      console.log(rulesItem, "rulesItem");
      return rulesItem;
    });

    const watchRules = () => {
      const index = rulesConfigInterface.findIndex(
        item => item.type === route.query.type
      );
      state.rulesEqual = _.isEqual(
        state.currentSelectRules,
        state.rulesConfigList[index]
      );
      let selectItem = getTreeDataByKey(state.treeData, state.currentSelectKey);

      if (selectItem) {
        console.log(selectItem, "selectItemselectItemselectItemrule");
        if (
          (selectItem.rules.startTime && selectItem.rules.startTime !== 0) ||
          (selectItem.rules.endTime && selectItem.rules.endTime !== 0)
        ) {
          if (globalState.value.timezone) {
            const find = state.timeZoneOption.find(item => {
              return item.label === globalState.value.timezone;
            });
            momentTimezone.tz.setDefault(find.value);
            console.log("走watch了？");
            console.log(
              selectItem.contents.rulesConfig.startTime,
              " selectItem.contents.rulesConfig.startTime "
            );
            if (selectItem.contents.rulesConfig.startTime) {
              let dateStartEqual = _.isEqual(
                selectItem.rules.startTime,
                momentTimezone(
                  selectItem.contents.rulesConfig.startTime * 1000
                ).unix()
              );
              selectItem.contents.rulesConfig.startTimeText = dateStartEqual
                ? momentTimezone(selectItem.rules.startTime * 1000).format(
                    "YYYY-MM-DD HH:mm:ss"
                  )
                : momentTimezone(
                    typeof selectItem.contents.rulesConfig.startTime ===
                      "string"
                      ? momentTimezone(
                          selectItem.contents.rulesConfig.startTime
                        ).unix() * 1000
                      : selectItem.contents.rulesConfig.startTime * 1000
                  ).format("YYYY-MM-DD HH:mm:ss");
            }
            if (selectItem.contents.rulesConfig.endTime) {
              let dateEndEqual = _.isEqual(
                selectItem.rules.endTime,
                momentTimezone(
                  selectItem.contents.rulesConfig.endTime * 1000
                ).unix()
              );

              selectItem.contents.rulesConfig.endTimeText = dateEndEqual
                ? momentTimezone(selectItem.rules.endTime * 1000).format(
                    "YYYY-MM-DD HH:mm:ss"
                  )
                : momentTimezone(
                    selectItem.contents.rulesConfig.endTime * 1000
                  ).format("YYYY-MM-DD HH:mm:ss");
            }
          }
        }
        if (!state.rulesEqual) {
          selectItem.contents.rulesConfig = state.rulesConfigList[index];
        }
      }
    };
    const radioChange = e => {
      console.log(e, "999999");
      state.rulesConfigList[3].lotteryType = Number(globalState.value.type);
    };
    const radioChangeInvite = e => {
      state.rulesConfigList[1].inviteType = Number(globalState.value.type);
    };
    const typeList = [
      {
        id: 1,
        title: "投票",
        img: require("@/assets/images/astronaut1.jpg")
      },
      {
        id: 4,
        title: "邀请好友",
        img: require("@/assets/images/astronaut2.jpg")
      },
      {
        id: 3,
        title: "答题",
        img: require("@/assets/images/astronaut3.jpg")
      },
      {
        id: 2,
        title: "抽奖",
        img: require("@/assets/images/astronaut4.jpg")
      }
    ];
    const currtentType = computed(() => {
      console.log(route, "route");
      const { query } = route;
      const currtentItem = typeList.find(
        item => item.id === Number(query.type)
      );
      return currtentItem;
    });
    const globalChange = async rules => {
      await getRegion();
      console.log(rules, "rulesrulesrules");
      console.log(state.timeZoneOption, " state.timeZoneOption");
      const find = state.timeZoneOption.find(item => {
        if (!rules.timezoneId) {
          return item.value === rules.timezone;
        } else {
          return item.id === rules.timezoneId;
        }
      });
      console.log(find, "findfind");
      let result = {
        timezone: find?.label,
        type: String(rules.type),
        addtionPoints: rules.addtionPoints,
        limit: rules.limit,
        depletePoints: rules.depletePoints
      };
      if (rules.startTime !== 0 || rules.endTime !== 0) {
        momentTimezone.tz.setDefault(find.value);
        result.time = [
          momentTimezone(rules.startTime * 1000).format("YYYY-MM-DD HH:mm:ss"),
          momentTimezone(rules.endTime * 1000).format("YYYY-MM-DD HH:mm:ss")
        ];
      }
      console.log(result, "result");
      return result;
    };
    const getTreeData = async () => {
      let params = {};
      const res = await activeDetail(params, route.query.id);
      const { data } = res;
      const rules = data.activitiesMeta.rules;
      state.treeData = res.data.activitiesMeta.activitiesNodes;
      if (Object.prototype.toString.call(rules) === "[object Object]") {
        globalState.value = await globalChange(rules);
      }
      shortTreeData(state.treeData);
    };
    const getRegion = async () => {
      const res = await region();
      state.timeZoneOption = res.data.region.map(item => {
        return {
          value: item.time_zone,
          label: item.region_name,
          id: item.id
        };
      });
    };
    const datepcikerStartChange = (date, item) => {
      let selectItem = getTreeDataByKey(state.treeData, state.currentSelectKey);
      const { contents } = selectItem;
      if (globalState.value.timezone) {
        const find = state.timeZoneOption.find(item => {
          return item.label === globalState.value.timezone;
        });
        momentTimezone.tz.setDefault(find.value);
        contents.rulesConfig.startTime = date && momentTimezone(date).unix();
      }
    };
    const datepcikerEndChange = (date, item) => {
      let selectItem = getTreeDataByKey(state.treeData, state.currentSelectKey);
      const { contents } = selectItem;
      if (globalState.value.timezone) {
        const find = state.timeZoneOption.find(item => {
          return item.label === globalState.value.timezone;
        });
        momentTimezone.tz.setDefault(find.value);
        contents.rulesConfig.endTime = date && momentTimezone(date).unix();
      }
    };
    const voteDateChange = (item, index) => {
      console.log(item, "itemitemitemitem");
      let selectItem = getTreeDataByKey(state.treeData, state.currentSelectKey);
      const { contents } = selectItem;
      console.log(contents, "/contents");
      console.log(globalState.value.timezone, "timezone");
      console.log(state.timeZoneOption, "state.timeZoneOption");
      if (globalState.value.timezone) {
        const find = state.timeZoneOption.find(item => {
          return item.label === globalState.value.timezone;
        });
        console.log(find, "findfind");
        momentTimezone.tz.setDefault(find.value);
        contents.rulesConfig.frequencyLimit[index].startTime = momentTimezone(
          item.time[0]
        ).unix();
        contents.rulesConfig.frequencyLimit[index].endTime = momentTimezone(
          item.time[1]
        ).unix();
      }
    };
    const treeSelect = (selectedKeys, e) => {
      let selectItem = getTreeDataByKey(state.treeData, selectedKeys?.[0]);
      const index = rulesConfigInterface.findIndex(
        item => item.type === route.query.type
      );
      if (selectItem) {
        state.currentSelectKey = selectedKeys[0];
        state.currentSelectRules = selectItem.rules;
        state.visible = true;
        state.currentForm = selectItem.contents.list;
        if (selectItem.contents.rulesConfig) {
          if (route.query.isDetail) {
            selectItem.rules.type = route.query.type;
            selectItem.rules.id = selectItem.id;
          }
          state.rulesConfigList[index] = selectItem.contents.rulesConfig;
        }
      }
      console.log(selectItem, "selectItem");
    };
    const shortTreeData = (child = []) => {
      for (let i = 0, len = child.length; i < len; i++) {
        let item = child[i];
        if (item.children && item.children.length > 0) {
          shortTreeData(item.children);
        }

        if (route.query.type === "4") {
          item.contents.rulesConfig = Object.assign(
            {
              type: route.query.type,
              id: item.id,
              inviteType: Number(globalState.value.type)
            },
            item.rules
          );
        } else {
          item.contents.rulesConfig = Object.assign(
            { type: route.query.type, id: item.id },
            item.rules
          );
        }
      }
    };
    const submitChange = async () => {
      const validate = await globalFormRef.value.validate();
      const { query } = route;
      const rulesData = {};
      if (globalState.value.timezone) {
        const find = state.timeZoneOption.find(item => {
          return (
            item.label === globalState.value.timezone ||
            item.value === globalState.value.timezone
          );
        });
        console.log(find, "findfind");
        rulesData.timezone = find.value;
        rulesData.timezoneId = find.id;
      }
      if (globalState.value.time && globalState.value.time.length !== 0) {
        momentTimezone.tz.setDefault(rulesData.timezone);
        rulesData.startTime = momentTimezone(globalState.value.time[0]).unix();
        rulesData.endTime = momentTimezone(globalState.value.time[1]).unix();
      }
      if (globalState.value.type) {
        rulesData.type = globalState.value.type;
      }
      if (globalState.value.limit) {
        rulesData.limit = globalState.value.limit;
      }
      if (globalState.value.addtionPoints) {
        rulesData.addtionPoints = globalState.value.addtionPoints;
      }
      if (globalState.value.depletePoints) {
        rulesData.depletePoints = globalState.value.depletePoints;
      }
      if (route.query.type === "4") {
        rulesData.type = globalState.value.type;
      }
      let params = {
        rules: rulesData,
        nodesRules: getTreeRulesConfig(state.treeData)
      };
      getTreeRulesConfig(state.treeData).length === 0 &&
      Object.keys(rulesData).length === 0
        ? (params.rulesStatus = 0)
        : (params.rulesStatus = 1);

      console.log(params, "params");
      try {
        const res = await ruleConfig(params, query.id);
        console.log(res, "res");
        message.success("设置成功！");
        router.push({ name: "listItem" });
      } catch (error) {
        const { data } = error.response;
        if (
          data.exception.type === "MandatoryValueMissingException" ||
          data.exception.type === "InvalidDataTypeException" ||
          data.exception.type === "DataEmptyException"
        ) {
          let text = "";
          let desc = "";
          switch (route.query.type) {
            case "1":
              desc = "投票";
              break;
            case "2":
              desc = "抽奖";
              break;
            case "3":
              desc = "答题";
              break;
            case "4":
              desc = "邀请";
              break;
          }
          switch (data.extra.key) {
            case "dayLimitTimes":
              text = "投票次数";
              break;
            case "description":
              text = "描述";
              break;
            case "winningWeight":
              text = "中奖概率";
              break;
            case "unwinningWeight":
              text = "未中奖概率";
              break;
            case "counts":
              text = "邀请数量";
              break;
            case "giftId":
              text = "礼包ID";
              break;
          }
          message.error(`节点上[${desc}]${text}没有填写`);
        }
      }
    };
    const drawWidth = computed(() => {
      return state.screenWidth > 2400 ? 400 : 390;
    });
    const closeVisibleChange = () => {
      state.visible = false;
    };
    const selectHandleChange = value => {
      console.log(value, "0000");
      globalState.value.timezone = state.timeZoneOption.find(
        item => item.label === value
      ).label;
    };
    watch(
      () => globalState.value.depletePoints,
      (depletePoints, prev) => {
        globalState.value.depletePoints =
          depletePoints && depletePoints.replace(/^(0+)|[^\d]+/g, "");
      }
    );
    watch(
      () => globalState.value.limit,
      (limit, prev) => {
        globalState.value.limit = limit && limit.replace(/^(0+)|[^\d]+/g, "");
      }
    );
    watchEffect(() => {
      watchRules();
    });

    onMounted(() => {
      getRegion();

      getTreeData();
    });
    return {
      typeList,
      currtentType,
      globalState,
      ...toRefs(state),
      treeSelect,
      drawWidth,
      closeVisibleChange,
      datepcikerStartChange,
      datepcikerEndChange,
      rulesConfig,
      submitChange,
      radioChange,
      radioChangeInvite,
      cardClass,
      globalRules,
      globalFormRef,
      rulesRef,
      selectRules,
      selectHandleChange,
      router,
      voteDateChange
    };
  }
});
</script>
<style lang="less">
.rules-card .ant-card-head {
  #flex-box.row-start();
}
.rules-card2 .ant-card-head {
  #flex-box.row-start();
}
.rules-card3 .ant-card-head {
  #flex-box.row-start();
}
.rules-card .ant-card-body .ant-form {
  #flex-box.row-b-c();
  .ant-form-item {
    #flex-box.column-c-start();
    width: 22%;
    .ant-form-item-control-wrapper {
      width: 100%;
    }
  }
}
.rules-card3 .ant-card-body .ant-form {
  #flex-box.row-b-c();
  .ant-form-item {
    #flex-box.column-c-start();
    width: 17%;
    .ant-form-item-control-wrapper {
      width: 100%;
    }
  }
}
.rules-card2 .ant-card-body .ant-form {
  #flex-box.row-b-c();
  .ant-form-item {
    #flex-box.column-c-start();
    width: 40%;
    .ant-form-item-control-wrapper {
      width: 100%;
    }
  }
}
.rules-form .ant-form-item .ant-form-item-control-wrapper {
  .ant-radio-group {
    #flex-box.column-start-start();
  }
  .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0 !important;
  }
}
.inviteClass .ant-form-item-control-wrapper .has-error .ant-form-explain {
  text-align: left;
}
</style>
<style lang='less' scoped>
//@import url(); 引入公共css类
@import "./index.less";
</style>